import { render, staticRenderFns } from "./jrcj.vue?vue&type=template&id=52d165f0&scoped=true&"
import script from "./jrcj.vue?vue&type=script&lang=js&"
export * from "./jrcj.vue?vue&type=script&lang=js&"
import style0 from "./jrcj.vue?vue&type=style&index=0&id=52d165f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d165f0",
  null
  
)

export default component.exports